import type { CSSProperties } from "react";
import { isCssLength, lengthBox } from "../purpose-sections/length";

function dimensionVariables(name: "width" | "height", raw: unknown) {
  if (typeof raw !== "string") return {};
  const [mobileRaw, desktopRaw = mobileRaw] = raw
    .split("|")
    .map((part) => part.trim());
  const value = (part: string) =>
    part === "auto" || (isCssLength(part) && !part.trim().startsWith("-"))
      ? part
      : undefined;
  const mobile = value(mobileRaw);
  const desktop = value(desktopRaw);
  return {
    ...(mobile ? { [`--re-nav-${name}`]: mobile } : {}),
    ...(desktop ? { [`--re-nav-${name}-desktop`]: desktop } : {}),
  };
}

/** Validated responsive geometry for the shared header action renderer. */
export function headerActionGeometryStyle(config: {
  padding?: string;
  width?: string;
  height?: string;
}): CSSProperties {
  const padding =
    typeof config.padding === "string" ? config.padding.split("|") : [];
  const mobilePadding = lengthBox(padding[0] ?? "");
  const desktopPadding = lengthBox(padding[1] ?? padding[0] ?? "");
  return {
    ...(mobilePadding ? { "--re-nav-padding": mobilePadding } : {}),
    ...(desktopPadding ? { "--re-nav-padding-desktop": desktopPadding } : {}),
    ...dimensionVariables("width", config.width),
    ...dimensionVariables("height", config.height),
  } as CSSProperties;
}
